import { render, staticRenderFns } from "./dialogAddBooking.vue?vue&type=template&id=c545398a&scoped=true"
import script from "./dialogAddBooking.vue?vue&type=script&lang=js"
export * from "./dialogAddBooking.vue?vue&type=script&lang=js"
import style0 from "./dialogAddBooking.vue?vue&type=style&index=0&id=c545398a&prod&lang=less&scoped=true"
import style1 from "./dialogAddBooking.vue?vue&type=style&index=1&id=c545398a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c545398a",
  null
  
)

export default component.exports